module.exports = __webpack_public_path__ + "img/bg_patrol_03.c444ca6c.jpg";